module.exports = __webpack_public_path__ + "static/step-three-2d43cdde023c273b24d916f1beb0bbad.png";